export default "{\n    \"clientUser\": \"Customer\",\n    \"vendorUser\": \"Vendor\",\n    \"internalUser\": \"ResQ\"\n}\n"